module.exports = __webpack_public_path__ + "img/Protractor-06.5183bce0.png";